import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Invoice,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}invoices/${COMMON_QUERY_PARAMS.KIND}/${COMMON_QUERY_PARAMS.ID}`;

export const KINK_TYPES = {
  FILE: 'File',
} as const;

export type KinkType = (typeof KINK_TYPES)[keyof typeof KINK_TYPES];

export interface GetInvoicesRequestArgs {
  kind: KinkType;
  id: string;
}

export const getInvoicesRequest = ({
  kind,
  id,
}: GetInvoicesRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.KIND, kind).replace(
    COMMON_QUERY_PARAMS.ID,
    id,
  ),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getInvoicesQuery = async ({
  kind,
  id,
}: GetInvoicesRequestArgs): Promise<
  BackResponse<Invoice[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<Invoice[]>>(
      getInvoicesRequest({ kind, id }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
